import { Card, CardContent } from "@/components/ui/card";
import { Trophy, ExternalLink, Globe, FileText, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const externalLinks = [
    {
      title: "Jockey Club",
      description: "Oficiální informace o českých dostizích",
      url: "http://www.dostihyjc.cz",
      icon: Trophy,
    },
    {
      title: "Fitmin & TURF Magazín",
      description: "Zpravodajství z českého dostihového sportu",
      url: "https://www.dostihy.fitmin.cz/",
      icon: Globe,
    },
    {
      title: "Závodiště Pardubice",
      description: "Oficiální stránky pardubického závodiště",
      url: "https://zavodistepardubice.cz",
      icon: Trophy,
    },
    {
      title: "Chuchle Arena Praha",
      description: "Pražský dostihový park Velká Chuchle",
      url: "https://www.chuchlearena.cz",
      icon: Trophy,
    },
  ];

  return (
    <footer className="bg-muted/20 border-t mt-4">
      <div className="container mx-auto px-4 py-4">
        <Card className="bg-transparent border-0 shadow-none">
          <CardContent className="p-0">
            <nav aria-label="Externí odkazy" className="mb-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                {externalLinks.map((link) => (
                  <a
                    key={link.url}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group block p-2 rounded-md hover:bg-accent/40 transition-colors"
                  >
                    <div className="flex items-start gap-2">
                      <link.icon className="h-4 w-4 mt-0.5 text-primary flex-shrink-0" />
                      <div className="flex-1 min-w-0">
                        <div className="font-medium group-hover:text-primary transition-colors flex items-center gap-1">
                          {link.title}
                          <ExternalLink className="h-3 w-3" />
                        </div>
                        <div className="text-xs text-muted-foreground mt-0.5 leading-snug hidden md:block">
                          {link.description}
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </nav>

            {/* Legal Documents Section */}
            <nav aria-label="Právní dokumenty" className="mb-4 border-t pt-4">
              <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
                <a
                  href="https://prezentace.horsebeat.cz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
                >
                  <FileText className="h-3 w-3" />
                  Pro firmy a partnerství
                </a>
                <span className="text-muted-foreground/60" aria-hidden="true">•</span>
                <Link 
                  to="/obchodni-podminky" 
                  className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
                >
                  <FileText className="h-3 w-3" />
                  Obchodní podmínky
                </Link>
                <span className="text-muted-foreground/60" aria-hidden="true">•</span>
                <Link 
                  to="/ochrana-osobnich-udaju" 
                  className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
                >
                  <FileText className="h-3 w-3" />
                  Ochrana osobních údajů
                </Link>
                <span className="text-muted-foreground/60" aria-hidden="true">•</span>
                <Link 
                  to="/reklamacni-rad" 
                  className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
                >
                  <FileText className="h-3 w-3" />
                  Reklamační řád
                </Link>
                <span className="text-muted-foreground/60" aria-hidden="true">•</span>
                <Link 
                  to="/odstoupeni-od-smlouvy" 
                  className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
                >
                  <FileText className="h-3 w-3" />
                  Odstoupení od smlouvy
                </Link>
              </div>
            </nav>

            <div className="border-t mt-4 pt-4 text-center">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Trophy className="h-3 w-3" />
                <span className="text-sm font-semibold">Horsebeat.cz</span>
              </div>
              <p className="text-xs text-muted-foreground">
                Dostihové statistiky - koní i žokejů, tipy a komunitní dostihová stáj.
              </p>
              
              {/* Social Media Links */}
              <div className="flex items-center justify-center gap-4 mt-3">
                <a
                  href="https://www.facebook.com/profile.php?id=61579698155981"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook className="h-5 w-5" />
                </a>
                <a
                  href="https://www.instagram.com/horsebeat.cz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="h-5 w-5" />
                </a>
              </div>
              
              <p className="text-xs text-muted-foreground mt-3">
                © {new Date().getFullYear()} • Všechna práva vyhrazena
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </footer>
  );
};